import React, { useContext } from "react";
import { Grid, Box, Skeleton, Text, Button, Center, useToast } from "@chakra-ui/react";
import AddProduct, { ProductInitialValueType } from "./AddProduct";
import Product from "./Product";
import { useMutation, useQuery } from "react-query";
import { addWomenUnderwear, getWomenUnderwears } from "../../services/products";
import { AdminContext } from "../../contexts/AdminContext";
import { useForm } from "@mantine/form";

const WUnderwearPanel = () => {
  const toast = useToast()
  const { admin } = useContext(AdminContext)
  const women_underwear = useQuery('women_underwear', getWomenUnderwears)

  const ProductInitialValues: ProductInitialValueType = {
    name: '',
    description: '',
    price: [],
    images: [],
  }

  const form = useForm({
    initialValues: ProductInitialValues,

    validate: {
      name: (value) => (
        !value ? 'Product name is required' : null
      ),
      description: (value) => (
        !value ? 'Product description must be at least 60 characters' : null
      ),
      price: (value) => (
        value.length < 1 ? 'Please add product pricing' : null
      ),
      images: (value) => (
        value.length < 1 ? 'Please add product pictures' : null
      ),
    },
  });

  const mutation = useMutation((data: ProductInitialValueType) => addWomenUnderwear(`bearer ${admin.token}`, data), {
    onError: () => {
      toast({
        title: "Failed to add product",
        status: 'error',
        isClosable: true,
        duration: 2000,
      })
    },

    onSuccess: () => {
      toast({
        title: "Product added",
        status: 'success',
        isClosable: true,
        duration: 2000
      })

      form.reset()
    },
  })

  return (
    <Grid
      templateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(2, 1fr)',
        'repeat(3, 1fr)',
        'repeat(4, 1fr)'
      ]} gap={6} mt='5'
    >
      <Box mb={[3]} w='100%' h="100%">
        <AddProduct
          form={form}
          mutation={mutation}
          product_type="Women's Underwears"
        />
      </Box>

      {women_underwear.data &&
        women_underwear.data.map((item: any) => (
          <Product data={item} key={item.id} />
        ))
      }

      {women_underwear.isLoading &&
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((num: number) => (
          <Skeleton key={num} h='40' w='100%' />
        ))
      }

      {women_underwear.isError &&
        <Center
          borderRadius='10px'
          borderWidth="2px"
          borderStyle="dashed"
          borderColor="#B5BAC1"
        >
          <Box textAlign='center'>
            <Text
              p='2' color='red.500'
              fontWeight='semibold'
            >
              Failed to products
            </Text>

            <Button colorScheme='green' size='md' onClick={() => women_underwear.refetch()}>
              Try again
            </Button>
          </Box>
        </Center>
      }
    </Grid>
  )
}

export default WUnderwearPanel